import { action, makeObservable, observable } from 'mobx';
import { cloned, cloneFailed, cloning, idle, State } from './Types';

class CloneStore {
  @observable
  state: State = idle();

  constructor() {
    makeObservable(this);
  }

  @action
  cloning = (collectionName: string) => {
    this.state = cloning(collectionName);
  };

  @action
  cloned = (newCollectionId: number, coursesNeedReview: boolean) => {
    const collectionName = this.state.kind === 'cloning' ? this.state.collectionName : '';
    this.state = cloned(newCollectionId, collectionName, coursesNeedReview);
  };

  @action
  failed = () => {
    this.state = cloneFailed();
  };

  @action
  reset = () => {
    this.state = idle();
  };
}

export default CloneStore;
